// 页面样式
import css from 'css/page/theme.scss'
// 动画
import {
  swiper
} from 'js/animation/index'
// 公共方法
import {
  domObserver,
  headerInit,
  memberShip,
} from 'js/common/index'

/**
 * 绑定 DOM 事件
 */
function bindEvts() {
  memberFormInit()
  swipersInit()
}

/**
 * 登录相关表单事件初始化
 */
function memberFormInit() {
  memberShip.closeForm.init()
  memberShip.forgetPwdFormInit({
    form: '.yui-memberform0-forgetpwd',
    mask: '.mask-member',
  })
  memberShip.loginFormInit({
    success: () => headerInit(),
    form: '.yui-memberform0-login',
    mask: '.mask-member',
  })
  memberShip.registerFormInit({
    form: '.yui-memberform0-register',
    mask: '.mask-member',
  })
}

/**
 * 滑块初始化
 */
function swipersInit() {
  // 顶部 banner
  swiper.init({
    selector: '.swiper0',
    options: {
      pagination: {
        bulletActiveClass: 'selected',
        bulletClass: 'dot',
        clickable: true,
        el: '.swiper-pagination-bullets',
      }
    }
  })
}

/**
 * UI 初始化
 */
function uiInit() {}

window._dataBus.get('domReadyObserver').subscribe(() => {
  uiInit()
  bindEvts()
})



// WEBPACK FOOTER //
// ./js/page/theme.js